import React, { useState, useEffect } from "react";
import api from "@/lib/api";
import { Link } from "lucide-react";
import { toast } from "sonner";

export default function AdminIntegrations() {
  const [integrations, setIntegrations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchIntegrations();
  }, []);

  const fetchIntegrations = async () => {
    try {
      const res = await api.get("/admin/integrations");
      setIntegrations(res.data.integrations);
    } catch (error) {
      toast.error("Erro ao carregar integrações");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-white">Integrações</h1>
        <p className="text-zinc-400 mt-1">Todas as integrações de todos os clientes</p>
      </div>

      <div className="bg-zinc-900 border border-zinc-800 rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-zinc-800/50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">
                  Cliente
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">
                  Provider
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">
                  Transações
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">
                  Criado em
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-800">
              {loading ? (
                <tr>
                  <td colSpan="5" className="px-6 py-12 text-center text-zinc-400">
                    Carregando...
                  </td>
                </tr>
              ) : integrations.length === 0 ? (
                <tr>
                  <td colSpan="5" className="px-6 py-12 text-center text-zinc-400">
                    Nenhuma integração encontrada
                  </td>
                </tr>
              ) : (
                integrations.map((integration) => (
                  <tr key={integration.id} className="hover:bg-zinc-800/30">
                    <td className="px-6 py-4">
                      <div>
                        <div className="font-medium text-white">{integration.user?.name}</div>
                        <div className="text-xs text-zinc-400">{integration.user?.email}</div>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-zinc-400">{integration.platform}</td>
                    <td className="px-6 py-4">
                      <span className={`px-2 py-1 rounded text-xs font-medium ${
                        integration.status === "active"
                          ? "bg-emerald-500/10 text-emerald-500"
                          : "bg-zinc-700 text-zinc-400"
                      }`}>
                        {integration.status || "inactive"}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-zinc-400">
                      {integration.transaction_count || 0}
                    </td>
                    <td className="px-6 py-4 text-zinc-400 text-sm">
                      {new Date(integration.created_at).toLocaleDateString("pt-BR")}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
